import produce from 'immer';
import { registerReducer } from '../../../StateSetup/RootReducer';

const { BFF_URL, GBCORE_CLIENT_NAME, GBCORE_CLIENT_VERSION } = window.__ENV__;

// Action names
const ACTION_NAME_PREFIX = 'action/getBank';
export const REQUEST_ACTION_NAME = `${ACTION_NAME_PREFIX}/request`;
export const RESPONSE_ACTION_NAME = `${ACTION_NAME_PREFIX}/response`;
export const ERROR_ACTION_NAME = `${ACTION_NAME_PREFIX}/error`;

/**
 * Gets bank information for a member.
 * @param {object} logger
 */
export const GetBank = (bankBranchNumber, bankInstitutionNumber) => {
    return async (dispatch, getState, { logger }) => {
        // step 1: Request Action
        dispatch({ type: REQUEST_ACTION_NAME });

        const { jwt, sessionCorrelationId, language } = getState().Authentication;
        const transactionId = logger.generateGuid();

        logger.info(`${ACTION_NAME_PREFIX}: Fetching bank data.`, { correlation: { transactionId } });

        // step 2: await Web service call
        const getBankQuery = await fetch(`${BFF_URL}/api/v2`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'gb-authorization': jwt,
                'mli-session-correlation-id': sessionCorrelationId,
                'mli-correlation-id': transactionId,
                'mli-channel': 'web',
                'gb-client-name': GBCORE_CLIENT_NAME,
                'gb-client-version': GBCORE_CLIENT_VERSION,
                'Accept-Language': language,
            },
            body: JSON.stringify({
                operationName: 'BankQuery',
                variables: { bankBranchNumber, bankInstitutionNumber },
                query: `
                    query BankQuery($bankBranchNumber: String, $bankInstitutionNumber: String) {
                        bank (branchNumber: $bankBranchNumber, institutionNumber: $bankInstitutionNumber) {
							bankName
						}
                    }
                `,
            }),
        });

        const getBankQueryResponse = await getBankQuery.json();

        if (getBankQueryResponse.errors) {
            const { message, code } = getBankQueryResponse.errors[0];
            logger.error(`${ACTION_NAME_PREFIX}: Failure when fetching bank data. Code: ${code} Reason: ${message}`, {
                correlation: { transactionId },
            });
            return dispatch({
                type: ERROR_ACTION_NAME,
                code,
                message,
            });
        }
        // step 3: Response Action
        return dispatch({ type: RESPONSE_ACTION_NAME, data: getBankQueryResponse.data.bank, success: true });
    };
};

export const requestReducer = produce((state) => {
    state.BankData.isLoadingBankData = true;
});

export const responseReducer = produce((state, action) => {
    state.BankData.isLoadingBankData = false;
    if (action.data) {
        state.BankData.bankName = action.data.bankName;
        state.BankData.isBankValid = true;
    } else {
        state.BankData.bankName = '';
        state.BankData.isBankValid = false;
    }
});

/**
 * Fired off when the request encouters an error.
 * @param {object} state
 * @param {object} action
 */
export const errorReducer = produce((state, action) => {
    state.BankData.isLoadingBankData = false;
    state.Errors.bankDataLoad.hasError = true;
    state.Errors.bankDataLoad.code = action.code;
    state.Errors.bankDataLoad.message = action.message;
});

registerReducer(REQUEST_ACTION_NAME, requestReducer);
registerReducer(RESPONSE_ACTION_NAME, responseReducer);
registerReducer(ERROR_ACTION_NAME, errorReducer);
